import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import AiFields from "../components/AIFields";
import { useTranslation } from 'react-i18next';

function PrincipalComponentsAnalysis({
    action,
    variables,
    setOpenVariable,
    automId,
}) {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();
    return (
        <div>
            <div className="form-element">
                <Button onClick={() => setOpen(true)} style={{
                    background: "#031226",
                    borderRadius: "2px",
                    color: "#fff",
                    fontSize: "12px",
                    fontWeight: 700,
                    textTransform: "none"
                }}>
                    {t('CONTENT.CONFIGURATION-FORM.AI.CONFIGURE')}
                </Button>
            </div>
            {open && (
                <AiFields
                    data={[
                        "model_id",
                        "training_frame",
                        "validation_frame",
                        "nfolds",
                        "ignore_const_cols",
                        "transform",
                        "pca_method",
                        "pca_impl",
                        "k*",
                        "max_iterations",
                        "use_all_factor_levels",
                        "compute_metrics",
                        "impute_missing",
                        "seed"
                    ]}
                    setOpen={setOpen}
                    action={action}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    automId={automId}
                />
            )}
        </div>
    );
}

export default PrincipalComponentsAnalysis;